import { useTranslation } from 'react-i18next';
import { BoundedContent, Box, Button, Column, GridContainer, H2, Icon, Link, Row } from '@vp/swan';
import FAQAccordion from '../../../../components/FAQAccordion/FAQAccordion';
import { sanitiseLocale } from '../../../../i18n/config';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { reactNodeToSanitizedText } from '../../../../utils/reactNodeToSanitizedText';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';
import { useFaqData } from './useFaqData';
import type { FAQSchema } from '../../../../components/FAQAccordion/FAQAccordion';

const Faq = () => {
    const faqData = useFaqData();
    const { t, i18n } = useTranslation();

    const faqSchemaData: FAQSchema[] = faqData.map((faq) => ({
        question: reactNodeToSanitizedText(faq.question),
        answer: reactNodeToSanitizedText(faq.answer),
    }));

    const logomakerGenAiPath = logomakerCtaPathByLocale(sanitiseLocale(i18n.language));
    const logomakerCTARef = useTrackNavigationClicked(
        'Design Services',
        'FAQ CTA',
        logomakerGenAiPath,
        'logoMaker',
    );
    return (
        <BoundedContent marginY="between-sections" id="logomaker-genai-faq" as="section">
            <GridContainer>
                <Row>
                    <Column span={12} padding={0}>
                        <H2 fontSkin="title-section">
                            {/* TODO: Update when FAQ copy is finalised */}
                            Your Logomaker questions, answered.
                        </H2>
                        <Box marginTop="between-subsections" marginBottom="to-actions">
                            <FAQAccordion faqData={faqData} faqSchemaData={faqSchemaData} />
                        </Box>
                    </Column>
                    <Column
                        span={12}
                        display={{ xs: 'none', sm: 'flex' }}
                        style={{ justifyContent: 'center' }}
                    >
                        <Button
                            skin={'primary'}
                            iconPosition={'left'}
                            render={(props) => (
                                <Link
                                    to={logomakerGenAiPath}
                                    className={props.className}
                                    ref={logomakerCTARef}
                                >
                                    {props.children}
                                </Link>
                            )}
                        >
                            <Icon alt="next step" iconType="magic" />
                            {t('Logomaker GenAi Landing Page > FAQs > CTA Button > Text.value')}
                        </Button>
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
};

export default Faq;
